export class CoolingWaterPara {
    constructor({
        id = ``,
        day = ``,
        time= ``,
        locName= ``,
        locId= ``,
        furnaceNumber = ``,
        tankPressure = ``,
        tankLiquidLevel = ``,
        reWaterPressure = ``,
        reWaterFlow = ``,
        flow1 = ``,
        pressure1 = ``,
        flow2 = ``,
        pressure2 = ``,
        flow3 = ``,
        pressure3 = ``,
        flow4 = ``,
        pressure4 = ``,
        flow5 = ``,
        pressure5 = ``,
        flow6 = ``,
        pressure6 = ``,
    }={}){
        this.id = id;
        this.day = day;
        this.time = time;
        this.locName = locName;
        this.locId = locId;
        this.furnaceNumber = furnaceNumber;
        this.tankPressure = tankPressure;
        this.tankLiquidLevel = tankLiquidLevel;
        this.reWaterPressure = reWaterPressure;
        this.reWaterFlow = reWaterFlow;
        this.flow1 = flow1;
        this.pressure1 = pressure1;
        this.flow2 = flow2;
        this.pressure2 = pressure2;
        this.flow3 = flow3;
        this.pressure3 = pressure3;
        this.flow4 = flow4;
        this.pressure4 = pressure4;
        this.flow5 = flow5;
        this.pressure5 = pressure5;
        this.flow6 = flow6;
        this.pressure6 = pressure6;
    }
}

export function gridFields(){
    return Object.freeze([
        {
            key: 'day',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
      {
          key: 'time',
          label: 'lbl.basic.datetime',
          sortable: true,
          form: {
            type: 'timepicker'
          }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'tankPressure',
            label: 'lbl.fm.tankPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'tankLiquidLevel',
            label: 'lbl.fm.tankLiquidLevel',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'reWaterPressure',
            label: 'lbl.fm.reWaterPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'reWaterFlow',
            label: 'lbl.fm.reWaterFlow',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'flow1',
            label: 'lbl.fm.flow1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'pressure1',
            label:'lbl.fm.pressure1',
            sortable:true,
            form: {
               type: 'input'
            }
        },
        {
            key: 'flow2',
            label: 'lbl.fm.flow2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'pressure2',
          label:'lbl.fm.pressure2',
          sortable:true,
          form: {
             type: 'input'
          }
        },
        {
            key: 'flow3',
            label: 'lbl.fm.flow3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'pressure3',
          label:'lbl.fm.pressure3',
          sortable:true,
          form: {
             type: 'input'
          }
        },
        {
            key: 'flow4',
            label: 'lbl.fm.flow4',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'pressure4',
          label:'lbl.fm.pressure4',
          sortable:true,
          form: {
             type: 'input'
          }
        },
        {
            key: 'flow5',
            label: 'lbl.fm.flow5',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'pressure5',
          label:'lbl.fm.pressure5',
          sortable:true,
          form: {
             type: 'input'
          }
        },
        {
            key: 'flow6',
            label: 'lbl.fm.flow6',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'pressure6',
          label:'lbl.fm.pressure6',
          sortable:true,
          form: {
             type: 'input'
          }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new CoolingWaterPara()).map(i => 'entity.'+i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.locNameFilter',
    'filter.furnaceNumberFilter',
];

export const filter = {
    'startTimeFilter' : '',
    'endTimeFilter' : '',
    'locNameFilter' : 'default',
    'furnaceNumberFilter' : 'default',
};